/**
 * Extrae el mensaje de error real de una descarga fallida (endpoints con responseType: 'blob').
 *
 * El interceptor de http.js ya convierte los blobs application/json a objeto antes de rechazar, así que
 * normalmente el error llega como objeto/string. Este helper cubre además el borde donde llega como Blob
 * (content-type no-json) o Error. Devuelve null si no puede extraer un mensaje: el caller usa su fallback.
 */
export async function downloadErrorMessage(error) {
  let data = error
  if (data instanceof Blob) {
    try { data = JSON.parse(await data.text()) } catch (e) { return null }
  }
  if (!data) return null
  if (typeof data === 'string') return data
  if (data instanceof Error) return data.message || null
  return (data.errors && data.errors.message) || data.message || null
}
